import React, { useState, useRef, useEffect, useCallback } from "react";

import { useNavigate, useLocation, useParams } from "react-router-dom";

import Swal from "sweetalert2";

import VandeMataram from "../../assets/images/badge/VandeMataram.png";

import "../profile/HeadProfile.css";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import { BsThreeDots } from "react-icons/bs";
import { AiFillMessage } from "react-icons/ai";
import { MdOutlineBlock } from "react-icons/md";
import { BsFlag } from "react-icons/bs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Cropper from "react-easy-crop";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import {
  faUser,
  faImage,
  faBookmark,
  faShareNodes,
  faLock,
  faLockOpen,
  faHeart,
  faVideo,
} from "@fortawesome/free-solid-svg-icons";
import QRCodePopup from "../model/QRCodePopup.jsx";
import CoverImg from "../../assets/images/profile/profileBanner.png";

//// Swiper for carousel start ////
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Keyboard } from "swiper/modules";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { messageApi } from "../../api/messageApi";
import { commentApi } from "../../api/commentApi";
import ReportModal from "../../components/report/ReportModal.jsx";
import { getCurrentUserId } from "../../utils/auth";
import { useReport } from "../../hook/useReport.jsx";
//// Swiper for carousel end ////

import { useProfile } from "../../hook/useProfile";
import DefaultProfile from "../../assets/images/profile/userProfile.png";
import DefaultCover from "../../assets/images/profile/profileBanner.png";
import PostCard from "../../components/Post/PostCard";
import ShareModal from "../../components/share/ShareModal";
import CommentModal from "../../components/commentCompo/comments/CommentModal";
import Button from "../ui/Button/Button";
import api from "../../api/axios";
import { feedApi } from "../../api/feedApi";
import { profileApi } from "../../api/profileApi";
import PostSkeleton from "../Post/PostSkeleton";
import ProfileSkeleton from "../ui/Skeletons/ProfileSkeleton.jsx";
import FrameModal from "../model/FrameModal.jsx";

// API BASE URL
const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function HeadProfile({ MyProfile }) {
  const feedScrollRef = useRef(null);
  const sentinelRef = useRef(null);
  const currentUserId = getCurrentUserId();
  const { userId } = useParams();

  // ── Cursor-based pagination refs ──────────────────────────────────────────
  const hasMoreRef = useRef(true);
  const hasMoreSavedRef = useRef(true);
  const loadingMoreRef = useRef(false);
  const loadingSavedMoreRef = useRef(false);
  const cursorRef = useRef(null);
  const savedCursorRef = useRef(null);
  const isFetchingRef = useRef(false);
  // ───────────────────────────────────────────────────────────────────────────

  // ── Role ref: persists across tab switches without re-fetching profile ────
  const profileRoleRef = useRef(null);
  // ───────────────────────────────────────────────────────────────────────────

  const { IsUserProfile } = useProfile();
  const isOwner = currentUserId === userId;

  //========== THREE DOTS DROP DOWN ============//
  const [isProfileActiveBtn, setIsProfileActiveBtn] = useState(false);
  const [IsSkeleton, setIsSkeleton] = useState(false);

  //========== FOR PROFILE DATA ============//
  const [messageStatus, setMessageStatus] = useState(null);
  const [profileData, setProfileData] = useState(null);
  const [profileLoading, setProfileLoading] = useState(true);
  const [profileError, setProfileError] = useState(null);
  const [isBlockedUser, setIsBlockedUser] = useState(null);
  const [isBlockedByUser, setIsBlockedByUser] = useState(null);
  const [isProfileLocked, setIsProfileLocked] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [showFrameModal, setShowFrameModal] = useState(false);
  const [isBadgeActive, setIsBadgeActive] = useState(false);

  // eye icon
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  //========== MESSAGE REQUEST STATES ============//
  const [showMsgRequestBox, setShowMsgRequestBox] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [sendingRequest, setSendingRequest] = useState(false);

  const [selectedImage, setSelectedImage] = useState(null);
  const [showCrop, setShowCrop] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [editType, setEditType] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [userRole, setUserRole] = useState(null);

  // ── Derived: is the visited profile a PRIME user?
  // Uses ref so it stays accurate even when switching tabs (no re-fetch needed)
  const isPrimeUser = userRole === "PRIME";

  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const updatePassword = async () => {
    if (!form.currentPassword || !form.newPassword || !form.confirmPassword) {
      toast.error("All fields are required");
      return;
    }
    if (form.newPassword.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    if (form.newPassword.length > 10) {
      toast.error("Password must not exceed 10 characters");
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      toast.error("New password and confirm password do not match");
      return;
    }

    setLoading(true);
    try {
      const res = await api.post("/user/change-password", {
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
        confirmPassword: form.confirmPassword,
      });
      toast.success(res.data.message);
      setForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
    } catch (err) {
      toast.error(err?.response?.data?.error || "Failed to change password");
    } finally {
      setLoading(false);
    }
  };

  const handleSendMessageRequest = async () => {
    try {
      setSendingRequest(true);
      const res = await messageApi.sendMessageRequest(userId, requestMessage);
      toast.success("Message request sent");
      setShowMsgRequestBox(false);
      setMessageStatus("REQUEST_SENT");
      setRequestMessage("");
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Failed to send message request",
      );
    } finally {
      setSendingRequest(false);
    }
  };

  // SHARE FUNCTIONALITY
  const [sharePost, setSharePost] = useState(null);
  const handleShareClick = (post) => setSharePost(post);
  const handleInternalShare = (post) => setSharePost(null);

  const handleExternalShare = async (post) => {
    const shareUrl = `${window.location.origin}/post/${post._id}`;
    if (navigator.share) {
      await navigator.share({ title: "Check this post", url: shareUrl });
    } else {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Link copied to clipboard");
    }
    setSharePost(null);
  };

  const handleRepost = async (post, description) => {
    try {
      const res = await api.post(`/feeds/${post._id}/repost`, { description });
      toast.success("Post reposted");
    } catch (err) {
      toast.error(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          "Something went wrong",
      );
    } finally {
      setSharePost(null);
    }
  };

  // post report
  const report = useReport({ onReported: (postId) => {} });
  const [reportLoading, setReportLoading] = useState(false);

  // for follower and following lists
  const [followListType, setFollowListType] = useState(null);
  const [followList, setFollowList] = useState([]);
  const [followListLoading, setFollowListLoading] = useState(false);
  const [showFollowSection, setShowFollowSection] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeFollowTab, setActiveFollowTab] = useState(null);
  const [profileView, setProfileView] = useState("profile");

  const filteredFollowList = followList.filter((user) =>
    user?.fullName?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const fetchFollowList = async (type) => {
    if (!profileData?._id) return;
    try {
      setFollowListLoading(true);
      setFollowList([]);
      const data = await profileApi.getFollowFollowingList({
        userId: profileData._id,
        type,
      });
      setFollowList(
        type === "followers" ? data.followers || [] : data.following || [],
      );
    } catch (err) {
      console.error("Follow list error:", err);
      setFollowList([]);
    } finally {
      setFollowListLoading(false);
    }
  };

  const handleFollowClick = (type) => {
    if (currentUserId !== profileData?._id) {
      toast.error("You can only view your own followers & following");
      setActiveFollowTab(null);
      setShowFollowSection(false);
      setIsActiveDataTab("profile");
      return;
    }
    setActiveFollowTab(type);
    setFollowListType(type);
    setShowFollowSection(true);
    setIsActiveDataTab("followers");
    fetchFollowList(type);
  };

  const openUserProfile = (userId) => {
    if (!userId) return;
    navigate(`/user/${userId}/profile`);
  };

  const getProfileImage = (profilePic) => {
    if (!profilePic)
      return "https://cdn-icons-png.flaticon.com/512/149/149071.png";
    if (profilePic.startsWith("http")) return profilePic;
    return `${profilePic}`;
  };

  const closeFollowSection = () => {
    setShowFollowSection(false);
    setFollowListType(null);
    setActiveFollowTab(null);
  };

  // State for comment delete
  const [postOwnerId, setPostOwnerId] = useState(null);
  const [activeMenuId, setActiveMenuId] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);
  const [deleteType, setDeleteType] = useState(null);
  const [parentCommentId, setParentCommentId] = useState(null);
  const [postCommentsCount, setPostCommentsCount] = useState(0);

  const handleDeleteComment = async () => {
    try {
      await commentApi.deleteComment(deleteTargetId);
      if (deleteType === "comment") {
        setComments((prev) => prev.filter((c) => c._id !== deleteTargetId));
        if (isActiveDataTab === "posts") {
          setMyPost((prev) =>
            prev.map((item) => {
              if (item._id !== activePost) return item;
              return {
                ...item,
                commentsCount: Math.max((item.commentsCount || 1) - 1, 0),
              };
            }),
          );
        }
        if (isActiveDataTab === "saveposts") {
          setSavedPosts((prev) =>
            prev.map((post) =>
              post._id === activePost
                ? {
                    ...post,
                    commentsCount: Math.max((post.commentsCount || 1) - 1, 0),
                  }
                : post,
            ),
          );
        }
      }
      if (deleteType === "reply") {
        setRepliesMap((prev) => ({
          ...prev,
          [parentCommentId]:
            prev[parentCommentId]?.filter((r) => r._id !== deleteTargetId) ||
            [],
        }));
        setComments((prev) =>
          prev.map((c) =>
            c._id === parentCommentId
              ? { ...c, repliesCount: Math.max((c.repliesCount || 1) - 1, 0) }
              : c,
          ),
        );
      }
      toast.success("Deleted successfully");
    } catch (err) {
      toast.error("Failed to delete");
    } finally {
      setShowDeleteConfirm(false);
      setDeleteTargetId(null);
      setDeleteType(null);
      setParentCommentId(null);
    }
  };

  //========== BLOCK UNBLOCK STATES ============//
  const [isBlocked, setIsBlocked] = useState(false);
  const [blockLoading, setBlockLoading] = useState(false);
  const [isRemoveProfile, setIsRemoveProfile] = useState();

  const handleBlockToggle = async () => {
    try {
      setBlockLoading(true);
      if (isBlockedUser) {
        await profileApi.unblockUser(userId);
        setIsBlocked(false);
        toast.success("User unblocked");
      } else {
        await profileApi.blockUser(userId);
        setIsBlocked(true);
        setFollowersCount(0);
        toast.success("User blocked");
      }
      await fetchUserProfile(userId);
      setIsProfileActiveBtn(false);
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Something went wrong",
      );
    } finally {
      setBlockLoading(false);
    }
  };

  //========== Handle Report Profile ============//
  // const [reportLoading, setReportLoading] = useState(false);

  // const handleReportProfile = async () => {
  //   const { value: reason } = await Swal.fire({
  //     title: "Report User",
  //     input: "textarea",
  //     width: "400px",
  //     height: "300px",
  //     inputPlaceholder: "Write reason for reporting...",
  //     inputAttributes: { maxlength: 200 },
  //     showCancelButton: true,
  //     confirmButtonText: "Submit",
  //     cancelButtonText: "Cancel",
  //     customClass: {
  //       confirmButton: "swal2-confirm-btn",
  //       cancelButton: "swal2-cancel-btn",
  //       input: "swal2-textarea",
  //     },
  //     inputValidator: (value) => {
  //       if (!value) toast.warning("Please enter a reason!");
  //     },
  //   });
  //   if (!reason) return;
  //   try {
  //     setReportLoading(true);
  //     await profileApi.reportProfile(userId, reason);
  //     toast.success("Reported successfully");
  //   } catch (error) {
  //     toast.error(
  //       error?.response?.data?.error ||
  //         error?.response?.data?.message ||
  //         "Something went wrong",
  //     );
  //   } finally {
  //     setReportLoading(false);
  //   }
  // };


  const REPORT_REASONS = {
    spam: [
      "Spam",
      "Fake Account",
      "Scam or fraud",
    ],

    abuse: [
      "Harassment, abuse, or harmful behavior",
      "Violence, hate, or inappropriate content",
    ],

    safety: [
      "Adult and prohibited content",
      "Child abuse (CSAM) and harassment",
      "Self-harm, suicide, or dangerous content",
      "Content involving individuals below the age of 18",
    ],

    intellectual: [
      "Intellectual property violation",
    ],

    other: [
      "Other",
    ],
  };

  const handleReportProfile = async () => {

    // ---------------- STEP 1 ----------------

    const { value: reason } = await Swal.fire({
      title: "Report Profile",

      width: 650,

      showCloseButton: true,

      showCancelButton: true,

      confirmButtonText: "Next",

      cancelButtonText: "Cancel",

      reverseButtons: true,

      focusConfirm: false,

      html: `
        <div class="report-wrapper">

          <div class="report-heading">
            Why are you reporting this profile?
          </div>

          <div class="report-list">

            ${Object.keys(REPORT_REASONS)
              .map(
                (key) => `
                  <div
                    class="report-item"
                    data-value="${key}"
                  >
                    <span>
                      ${
                        key.charAt(0).toUpperCase() +
                        key.slice(1)
                      }
                    </span>

                    <span class="report-arrow">
                      &#8250;
                    </span>

                  </div>
                `
              )
              .join("")}

          </div>

        </div>
      `,

      didOpen: () => {
        const items = document.querySelectorAll(".report-item");

        items.forEach((item) => {
          item.addEventListener("click", () => {
            items.forEach((i) => i.classList.remove("selected"));
            item.classList.add("selected");
          });
        });
      },

      preConfirm: () => {
        const selected = document.querySelector(".report-item.selected");

        if (!selected) {
          Swal.showValidationMessage("Please select a reason.");
          return false;
        }

        return selected.dataset.value;
      },

      customClass: {
        popup: "report-popup",
        title: "report-title",
        closeButton: "report-close",
        confirmButton: "report-next-btn",
        cancelButton: "report-cancel-btn",
      },
    });

    if (!reason) return;

    // ---------------- STEP 2 ----------------

    const { value: subReason } = await Swal.fire({
      title: "Report Profile",

      // width: "600px",

      showCloseButton: true,

      showCancelButton: true,

      confirmButtonText: "Submit",

      cancelButtonText: "Back",

      reverseButtons: true,

      focusConfirm: false,

      html: `
        <div class="report-wrapper">

          <div class="report-heading">
            Give us more details
          </div>

          <div class="report-list">

            ${REPORT_REASONS[reason]
              .map(
                (item) => `
                  <div
                    class="report-item"
                    data-value="${item}"
                  >
                    <span>${item}</span>

                    <span class="report-arrow">
                      &#8250;
                    </span>

                  </div>
                `
              )
              .join("")}

          </div>

        </div>
      `,

      didOpen: () => {
        const items = document.querySelectorAll(".report-item");

        items.forEach((item) => {
          item.addEventListener("click", () => {
            items.forEach((i) => i.classList.remove("selected"));
            item.classList.add("selected");
          });
        });
      },

      preConfirm: () => {
        const selected = document.querySelector(".report-item.selected");

        if (!selected) {
          Swal.showValidationMessage("Please select a reason.");
          return false;
        }

        return selected.dataset.value;
      },

      customClass: {
        popup: "report-popup",
        title: "report-title",
        closeButton: "report-close",
        confirmButton: "report-next-btn",
        cancelButton: "report-cancel-btn",
      },
    });

    if (!subReason) return;

    try {

      setReportLoading(true);

      await profileApi.reportProfile(userId, subReason);

      toast.success("Profile reported successfully");

    } catch (error) {

      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Something went wrong"
      );

    } finally {

      setReportLoading(false);

    }
  };

  const [followersCount, setFollowersCount] = useState(0);
  const [postCount, setPostCount] = useState(0);
  const profile = MyProfile;

  const fetchMyProfile = async () => {
    try {
      setIsSkeleton(true);
      const res = await api.get("/user/me");
      setProfileData(res?.data?.user);
      setIsRemoveProfile(res?.data?.user);
      setIsProfileLocked(res?.data?.user?.isProfileLocked);
      setPostCount(res?.data?.user?.postsCount);
      setIsSkeleton(false);
    } catch (err) {
      console.error("Profile fetch error", err);
      setProfileError("Failed to load profile");
      setIsSkeleton(false);
    } finally {
      setProfileLoading(false);
    }
  };

  // For other user's profile follow unfollow
  const [followStatus, setFollowStatus] = useState(null);
  const [isUserProfileLocked, setIsUserProfileLocked] = useState(false);
  const [followProfileLoading, setFollowProfileLoading] = useState(false);
  const [followLoading, setFollowLoading] = useState({});

  const handleFollow = async () => {
    if (followProfileLoading) return;
    try {
      setFollowLoading(true);
      await feedApi.followUser({ userId });
      setFollowStatus("FOLLOWING");
      setFollowersCount((prev) => prev + 1);
    } catch (err) {
      console.error(err);
    } finally {
      setFollowLoading(false);
    }
  };

  const handleSendFollowRequest = async () => {
    if (followProfileLoading) return;
    try {
      setFollowLoading(true);
      await feedApi.requestFollow({ userId });
      setFollowStatus("REQUESTED");
    } catch (err) {
      console.error(err);
    } finally {
      setFollowLoading(false);
    }
  };

  const handleUnfollow = async () => {
    if (followProfileLoading) return;
    try {
      setFollowLoading(true);
      await feedApi.unfollowUser({ userId });
      setFollowStatus("NONE");
      setFollowersCount((prev) => prev - 1);
    } catch (err) {
      console.error(err);
    } finally {
      setFollowLoading(false);
    }
  };

  const handleAadhaarVerify = () => {
    navigate("/aadhaar-verification", { state: { fromProfile: true, userId } });
  };

  const handleCancelRequest = async () => {
    if (followProfileLoading) return;
    try {
      setFollowLoading(true);
      await feedApi.requestCancel({ userId });
      setFollowStatus("NONE");
    } catch (err) {
      console.error(err);
    } finally {
      setFollowLoading(false);
    }
  };

  const fetchUserProfile = async (userId) => {
    if (!userId) return;

    try {
      setIsSkeleton(true);

      const res = await api.get(`/user/${userId}/profile`);

      const role = res?.data?.publicInfo?.role;

      // console.log("API role:", role);

      // ── Save role to both state (for re-renders) AND ref (persists across tab switches) ──
      setUserRole(role);
      profileRoleRef.current = role;
      // ────────────────────────────────────────────────────────────────────────────────────

      setIsBlockedUser(res.data.isBlocked || res.data.isBlockedByMe);
      setIsBlockedByUser(res.data.isBlockedByUser);
      setMessageStatus(res.data.messageStatus);
      setProfileData(res.data.publicInfo);

      setFollowStatus(res.data.followStatus);
      setIsUserProfileLocked(res.data.isLocked);
      setFollowersCount(res.data.publicInfo.stats.followers);

      setIsSkeleton(false);
    } catch (err) {
      console.error("Profile fetch error", err);
      setProfileError("Failed to load profile");
      setIsSkeleton(false);
    } finally {
      setProfileLoading(false);
    }
  };

  const isAadhaarVerified = profileData?.adhaarVerified === "VERIFIED";
  const isAadhaarRequested = profileData?.adhaarVerified === "REQUESTED";
  const isAadhaarNone = profileData?.adhaarVerified === "NONE";
  const isAadhaarRejected = profileData?.adhaarVerified === "REJECTED";
  const isPrime = isPrimeUser || profileData?.role === "PRIME";

  const navigate = useNavigate();
  const routerLocation = useLocation();

  useEffect(() => {
    if (!userId) return;
    setProfileLoading(true);
    setProfileData(null);
    setMyPost([]);
    setSavedPosts([]);
    setHasMore(true);

    // ── Reset role ref whenever we navigate to a different user's profile ──
    profileRoleRef.current = null;
    // ───────────────────────────────────────────────────────────────────────

    if (currentUserId === userId) {
      fetchMyProfile();
    } else {
      fetchUserProfile(userId);
    }
  }, [userId, routerLocation?.pathname]);

  const { isProfileInfo, setIsProfileInfo, updateProfile } = useProfile();

  const isLoggedInPrimeUser = isProfileInfo?.role === "PRIME";

  // --- Refs for file inputs ---
  const fileInputRef = useRef(null);
  const coverInputRef = useRef(null);
  const profileRef = useRef(null);
  const coverDropDownRef = useRef(null);
  const profileDropDownRef = useRef(null);
  const buttonRef = useRef(null);

  const [profileImage, setProfileImage] = useState();
  const [coverImage, setCoverImage] = useState();
  const [coverFile, setCoverFile] = useState(null);
  const [activeTab, setActiveTab] = useState("personal");

  const handleFun = () => navigate("/edit-profile");

  const handleCoverSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setCoverFile(file);
    setCoverImage(URL.createObjectURL(file));
  };

  const goOnChat = () => {
    navigate(`/message/${userId}`, {
      state: {
        userID: userId,
        fullName: profileData?.fullName,
        profilePic: profileData?.profilePic,
        messageStatus: IsUserProfile?.messageStatus,
        followingStatus: IsUserProfile?.followStatus,
      },
    });
  };

  // ── Posts state (cursor-based) ────────────────────────────────────────────
  const [myPost, setMyPost] = useState([]);
  const [savedPosts, setSavedPosts] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [hasMoreSaved, setHasMoreSaved] = useState(true);
  const [cursor, setCursor] = useState(null);
  const [savedCursor, setSavedCursor] = useState(null);
  const PROFILE_LIMIT = 10;
  const videoRefs = useRef(new Map());
  const [activeImages, setActiveImages] = useState([]);
  const [showImageModal, setShowImageModal] = useState(false);
  const [isActiveDataTab, setIsActiveDataTab] = useState("profile");
  const [loadingMore, setLoadingMore] = useState(false);
  const [loadingSavedMore, setLoadingSavedMore] = useState(false);
  // ───────────────────────────────────────────────────────────────────────────

  // Helper function to normalize posts from API response
  const normalizePosts = useCallback((posts) => {
    if (!posts || !Array.isArray(posts)) return [];

    return posts.map((item) => {
      // If item has a nested 'post' property (API response format)
      if (item.post && !item._id) {
        if (item.type === "REPOST") {
          return {
            ...item,
            isRepost: true,
            originalPost: item.post,
            repostedBy: item.repostedBy,
            repostedAt: item.createdAt,
            _id: item._id || item.post._id,
            createdAt: item.createdAt || item.post.createdAt,
            user: item.post.user,
            description: item.post.description,
            images: item.post.images,
            video: item.post.video,
            likesCount: item.post.likesCount,
            commentsCount: item.post.commentsCount,
            repostsCount: item.post.repostsCount,
            isLiked: item.post.isLiked || false,
            isSaved: item.post.isSaved || false,
            isFollowing: item.post.isFollowing || false,
          };
        } else {
          return {
            ...item.post,
            type: item.type,
            repostedBy: item.repostedBy,
            createdAt: item.createdAt || item.post.createdAt,
            isRepost: false,
            isLiked: item.post.isLiked || false,
            isSaved: item.post.isSaved || false,
            isFollowing: item.post.isFollowing || false,
          };
        }
      }
      // If item is already flat
      return item;
    });
  }, []);

  // ── Fetch functions with cursor-based pagination ──────────────────────────

  const fetchMyPosts = useCallback(
    async (cursorParam = null) => {
      if (cursorParam === null && !hasMoreRef.current) return;
      if (isFetchingRef.current && cursorParam !== null) return;

      isFetchingRef.current = true;
      if (cursorParam === null) {
        setLoading(true);
      } else {
        loadingMoreRef.current = true;
        setLoadingMore(true);
      }

      try {
        const data = await profileApi.getMyPosts({
          cursor: cursorParam,
          limit: PROFILE_LIMIT,
        });

        const rawPosts = data.posts || [];
        const newPosts = normalizePosts(rawPosts);

        setMyPost((prev) => {
          if (cursorParam === null) return newPosts;
          const existingIds = new Set(prev.map((p) => p._id));
          const uniqueNewPosts = newPosts.filter(
            (p) => !existingIds.has(p._id),
          );
          return [...prev, ...uniqueNewPosts];
        });

        setHasMore(data.hasMore);
        hasMoreRef.current = data.hasMore;

        if (data.nextCursor) {
          setCursor(data.nextCursor);
          cursorRef.current = data.nextCursor;
        } else {
          setCursor(null);
          cursorRef.current = null;
        }
      } catch (err) {
        if (err.name !== "CanceledError")
          console.error("My Posts API Error:", err);
      } finally {
        isFetchingRef.current = false;
        loadingMoreRef.current = false;
        setLoading(false);
        setLoadingMore(false);
      }
    },
    [normalizePosts],
  );

  const fetchSavedPosts = useCallback(
    async (cursorParam = null) => {
      if (cursorParam === null && !hasMoreSavedRef.current) return;
      if (isFetchingRef.current && cursorParam !== null) return;

      isFetchingRef.current = true;
      if (cursorParam === null) {
        setLoading(true);
      } else {
        loadingSavedMoreRef.current = true;
        setLoadingSavedMore(true);
      }

      try {
        const data = await profileApi.getSavedPosts({
          cursor: cursorParam,
          limit: PROFILE_LIMIT,
        });

        const rawPosts = data.posts || [];
        let newPosts = normalizePosts(rawPosts);
        newPosts = newPosts.map((post) => ({ ...post, isSaved: true }));

        setSavedPosts((prev) => {
          if (cursorParam === null) return newPosts;
          const existingIds = new Set(prev.map((p) => p._id));
          const uniqueNewPosts = newPosts.filter(
            (p) => !existingIds.has(p._id),
          );
          return [...prev, ...uniqueNewPosts];
        });

        setHasMoreSaved(data.hasMore);
        hasMoreSavedRef.current = data.hasMore;

        if (data.nextCursor) {
          setSavedCursor(data.nextCursor);
          savedCursorRef.current = data.nextCursor;
        } else {
          setSavedCursor(null);
          savedCursorRef.current = null;
        }
      } catch (err) {
        if (err.name !== "CanceledError")
          console.error("Saved Posts API Error:", err);
      } finally {
        isFetchingRef.current = false;
        loadingSavedMoreRef.current = false;
        setLoading(false);
        setLoadingSavedMore(false);
      }
    },
    [normalizePosts],
  );

  const fetchUserPosts = useCallback(
    async (cursorParam = null) => {
      if (cursorParam === null && !hasMoreRef.current) return;
      if (isFetchingRef.current && cursorParam !== null) return;

      isFetchingRef.current = true;
      if (cursorParam === null) {
        setLoading(true);
      } else {
        loadingMoreRef.current = true;
        setLoadingMore(true);
      }

      try {
        const data = await profileApi.getUserPosts({
          userId,
          cursor: cursorParam,
          limit: PROFILE_LIMIT,
        });

        const rawPosts = data.posts || [];
        const newPosts = normalizePosts(rawPosts);

        setMyPost((prev) => {
          if (cursorParam === null) return newPosts;
          const existingIds = new Set(prev.map((p) => p._id));
          const uniqueNewPosts = newPosts.filter(
            (p) => !existingIds.has(p._id),
          );
          return [...prev, ...uniqueNewPosts];
        });

        setHasMore(data.hasMore);
        hasMoreRef.current = data.hasMore;

        if (data.nextCursor) {
          setCursor(data.nextCursor);
          cursorRef.current = data.nextCursor;
        } else {
          setCursor(null);
          cursorRef.current = null;
        }
      } catch (err) {
        if (err.name !== "CanceledError")
          console.error("User Posts API Error:", err);
      } finally {
        isFetchingRef.current = false;
        loadingMoreRef.current = false;
        setLoading(false);
        setLoadingMore(false);
      }
    },
    [userId, normalizePosts],
  );

  // ───────────────────────────────────────────────────────────────────────────

  // ── Tab change: reset all cursor state then fetch first page ──────────────
  useEffect(() => {
    if (isActiveDataTab === "posts") {
      if (profileRoleRef.current !== null && userRole === null) {
        setUserRole(profileRoleRef.current);
      }
      // Reset all cursor state
      setCursor(null);
      cursorRef.current = null;
      setHasMore(true);
      hasMoreRef.current = true;
      setMyPost([]);
      isFetchingRef.current = false;
      loadingMoreRef.current = false;

      if (isOwner) {
        fetchMyPosts(null);
      } else {
        fetchUserPosts(null);
      }
    }

    if (isActiveDataTab === "saveposts") {
      // Reset all cursor state for saved posts
      setSavedCursor(null);
      savedCursorRef.current = null;
      setHasMoreSaved(true);
      hasMoreSavedRef.current = true;
      setSavedPosts([]);
      isFetchingRef.current = false;
      loadingSavedMoreRef.current = false;
      fetchSavedPosts(null);
    }
  }, [isActiveDataTab, fetchMyPosts, fetchUserPosts, fetchSavedPosts, isOwner]);
  // ───────────────────────────────────────────────────────────────────────────

  // ── IntersectionObserver: fires when sentinel div enters viewport ──────────
  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) {
      // console.log("Sentinel ref is null, waiting for element to render");
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) return;
        if (isFetchingRef.current) {
          console.log("Already fetching, skipping");
          return;
        }

        if (isActiveDataTab === "posts" && hasMoreRef.current) {
          const nextCursor = cursorRef.current;
          if (nextCursor) {
            console.log("Loading more posts with cursor:", nextCursor);
            if (isOwner) {
              fetchMyPosts(nextCursor);
            } else {
              fetchUserPosts(nextCursor);
            }
          } else {
            console.log("No cursor available but hasMore is true");
          }
        }

        if (isActiveDataTab === "saveposts" && hasMoreSavedRef.current) {
          const nextCursor = savedCursorRef.current;
          if (nextCursor) {
            console.log("Loading more saved posts with cursor:", nextCursor);
            fetchSavedPosts(nextCursor);
          }
        }
      },
      {
        threshold: 0.1,
        rootMargin: "100px",
        root: null,
      },
    );

    observer.observe(sentinel);

    return () => {
      observer.disconnect();
    };
  }, [
    isActiveDataTab,
    isOwner,
    fetchMyPosts,
    fetchUserPosts,
    fetchSavedPosts,
    myPost.length,
  ]);
  // ───────────────────────────────────────────────────────────────────────────

  const handleShareProfile = async () => {
    try {
      const profileUrl = `${window.location.origin}/my/${profileData?._id}/profile`;
      if (navigator.share) {
        await navigator.share({
          title: `${profileData?.fullName}'s Profile`,
          text: `Check out this profile on BharatJagriti`,
          url: profileUrl,
        });
      } else {
        await navigator.clipboard.writeText(profileUrl);
        toast.success("Profile link copied to clipboard");
      }
    } catch (error) {
      console.error("Share failed:", error);
    }
  };

  const isMyProfile =
    isProfileInfo?._id && MyProfile?._id && isProfileInfo._id === MyProfile._id;

  useEffect(() => {
    if (MyProfile?.profilePic && !profileImage)
      setProfileImage(MyProfile.profilePic);
    if (MyProfile?.coverPic && !coverImage) setCoverImage(MyProfile.coverPic);
  }, [MyProfile]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        coverDropDownRef.current &&
        !coverDropDownRef.current.contains(e.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target)
      ) {
        setIsCoverDropDownShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        profileDropDownRef.current &&
        !profileDropDownRef.current.contains(e.target)
      ) {
        setIsActive(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const openFilePicker = () => fileInputRef.current.click();
  const openCoverPicker = () => coverInputRef.current.click();

  const handleProfileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setEditType("profile");
    setSelectedFile(file);
    const reader = new FileReader();
    reader.onload = () => {
      setSelectedImage(reader.result);
      setShowCrop(true);
    };
    reader.readAsDataURL(file);
    e.target.value = null;
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCoverChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setEditType("cover");
    setSelectedFile(file);
    const reader = new FileReader();
    reader.onload = () => {
      setSelectedImage(reader.result);
      setShowCrop(true);
    };
    reader.readAsDataURL(file);
    e.target.value = null;
  };

  const createImage = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.addEventListener("load", () => resolve(img));
      img.addEventListener("error", (error) => reject(error));
      img.src = url;
    });

  const getCroppedImg = async (imageSrc, crop) => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = crop.width;
    canvas.height = crop.height;
    ctx.drawImage(
      image,
      crop.x,
      crop.y,
      crop.width,
      crop.height,
      0,
      0,
      crop.width,
      crop.height,
    );
    return canvas.toDataURL("image/jpeg");
  };

const handleCropSave = async () => {
  try {
    const croppedImage = await getCroppedImg(
      selectedImage,
      croppedAreaPixels
    );

    setShowCrop(false);

    const blob = await fetch(croppedImage).then((res) => res.blob());

    const file = new File(
      [blob],
      `${editType}-${Date.now()}.jpg`,
      {
        type: "image/jpeg",
      }
    );

    // Update preview immediately
    if (editType === "profile") {
      setProfileImage(croppedImage);

      await profileApi.updateProfileImage({
        file,
      });

      toast.success("Profile picture updated successfully");
    }

    if (editType === "cover") {
      setCoverImage(croppedImage);

      await profileApi.updateCoverImage({
        file,
      });

      toast.success("Cover picture updated successfully");
    }

    setEditType(null);
    setSelectedImage(null);
  } catch (error) {
    console.error(
      "Image update error:",
      error.response?.data || error
    );

    toast.error(
      error.response?.data?.error ||
        error.message ||
        "Failed to update image"
    );
  }
};


  const handleFollowToggle = async (post) => {
    const userId = post?.user?._id;
    if (!userId) return;

    setMyPost((prevPosts) =>
      prevPosts.map((item) => {
        if (item.user?._id !== userId && item.post?.user?._id !== userId)
          return item;
        return { ...item, isFollowing: !item.isFollowing };
      }),
    );

    setSavedPosts((prevPosts) =>
      prevPosts.map((item) => {
        if (item.user?._id !== userId && item.post?.user?._id !== userId)
          return item;
        return { ...item, isFollowing: !item.isFollowing };
      }),
    );

    try {
      if (post?.isFollowing) {
        await feedApi.unfollowUser({ userId });
      } else {
        await feedApi.followUser({ userId });
      }
    } catch (error) {
      console.error("Follow failed", error);
    }
  };

  // Edit modal state
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingPost, setEditingPost] = useState(null);
  const [editText, setEditText] = useState("");
  const [editImages, setEditImages] = useState([]);
  const [editVideo, setEditVideo] = useState(null);
  const [editVideoType, setEditVideoType] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const editImageInputRef = useRef(null);
  const editVideoInputRef = useRef(null);

  const handleEditPost = (post) => {
    setEditingPost(post);
    setEditText(post.description || "");
    if (post.images?.length) {
      setEditImages(
        post.images.map((img) => ({
          file: null,
          preview: `${img.replace(/\\/g, "/")}`,
        })),
      );
      setEditVideo(null);
      setEditVideoType("");
    }
    if (post.video) {
      setEditVideo({
        file: null,
        preview: `${post.video.replace(/\\/g, "/")}`,
        duration: post.videoDuration || 0,
      });
      setEditVideoType(post.videoDuration <= 60 ? "short" : "long");
      setEditImages([]);
    }
    setShowEditModal(true);
  };

  const handleEditImageSelect = (e) => {
    if (editVideo) {
      toast.warning("Remove video to add images");
      e.target.value = "";
      return;
    }
    const files = Array.from(e.target.files);
    if (!files.length) return;
    if (files.length > 10) {
      toast.warning("Max 10 images allowed");
      e.target.value = "";
      return;
    }
    setEditImages(
      files.map((file) => ({ file, preview: URL.createObjectURL(file) })),
    );
    e.target.value = "";
  };

  const handleRemoveEditImage = (index) => {
    setEditImages((prev) => prev.filter((_, i) => i !== index));
    if (editImageInputRef.current) editImageInputRef.current.value = "";
  };

  const handleEditVideoSelect = (e) => {
    if (editImages.length > 0) {
      toast.warning("Remove images to add video");
      return;
    }
    const file = e.target.files[0];
    if (!file) return;
    const video = document.createElement("video");
    video.preload = "metadata";
    video.onloadedmetadata = () => {
      setEditVideo({
        file,
        preview: URL.createObjectURL(file),
        duration: video.duration,
      });
      setEditVideoType(video.duration <= 60 ? "short" : "long");
    };
    video.src = URL.createObjectURL(file);
  };

  const handleRemoveEditVideo = () => {
    setEditVideo(null);
    setEditVideoType("");
  };

  const handleUpdatePost = async () => {
    if (!editingPost) return;
    setIsUpdating(true);
    try {
      const data = await feedApi.updatePost({
        postId: editingPost._id,
        description: editText,
        images: editImages,
        video: editVideo,
      });
      const updatedPost = data.post;
      setMyPost((prev) =>
        prev.map((item) => {
          if (item._id !== updatedPost._id) return item;
          return { ...item, ...updatedPost };
        }),
      );
      setShowEditModal(false);
      setEditingPost(null);
    } catch (err) {
      console.error("Edit failed", err);
    } finally {
      setIsUpdating(false);
    }
  };

  const handleDeletePost = async (postId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });
    if (!result.isConfirmed) return;
    setMyPost((prev) => prev.filter((item) => item._id !== postId));
    try {
      await feedApi.deletePost({ postId });
      setPostCount((prev) => prev - 1);
    } catch (error) {
      console.error("Delete failed", error);
      toast.error("Delete failed");
      if (isOwner) {
        fetchMyPosts(null);
      } else {
        fetchUserPosts(null);
      }
    }
  };

  const handleLikeToggle = async (postId) => {
    if (isActiveDataTab === "posts") {
      setMyPost((prevPosts) =>
        prevPosts.map((item) => {
          if (item._id !== postId) return item;
          const isLiked = item.isLiked;
          return {
            ...item,
            isLiked: !isLiked,
            likesCount: isLiked ? item.likesCount - 1 : item.likesCount + 1,
          };
        }),
      );
    }
    if (isActiveDataTab === "saveposts") {
      setSavedPosts((prevPosts) =>
        prevPosts.map((post) =>
          post._id === postId
            ? {
                ...post,
                isLiked: !post.isLiked,
                likesCount: post.isLiked
                  ? post.likesCount - 1
                  : post.likesCount + 1,
              }
            : post,
        ),
      );
    }
    try {
      await feedApi.toggleLike({ postId });
    } catch (error) {
      console.error("Like failed", error);
    }
  };

  // const handleSaveToggle = async (postId) => {

  //   if (isActiveDataTab === "posts") {
  //     setMyPost((prev) =>
  //       prev.map((item) => {
  //         if (item._id !== postId) return item;
  //         return { ...item, isSaved: !item.isSaved };
  //       }),
  //     );
  //   }
    
  //   if (isActiveDataTab === "saveposts") {
  //     setSavedPosts((prev) => prev.filter((item) => item._id !== postId));
  //   }
  //   try {
  //     await feedApi.toggleSave({ postId });
  //   } catch (error) {
  //     console.error("Save failed", error);
  //   }
  // };



  const handleSaveToggle = async (postId) => {
    try {
      // 🔥 Call API FIRST to get correct saved state
      const res = await feedApi.toggleSave({ postId });

      if (isActiveDataTab === "posts") {
        setMyPost((prev) =>
          prev.map((item) => {
            // ✅ Normal Post
            if (item._id === postId) {
              return {
                ...item,
                isSaved: res.saved,
              };
            }

            // 🔥 Repost FIX
            if (item?.post?._id === postId) {
              return {
                ...item,
                post: {
                  ...item.post,
                  isSaved: res.saved,
                },
              };
            }

            return item;
          })
        );
      }

      // ✅ Saved Post tab handling (remove unsaved items)
      if (isActiveDataTab === "saveposts") {
        setSavedPosts((prev) =>
          prev.filter(
            (item) =>
              item._id !== postId && item?.post?._id !== postId
          )
        );
      }
    } catch (error) {
      console.error("Save failed", error);
    }
  };


  // Comment modal state
  const [activePost, setActivePost] = useState(null);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [comments, setComments] = useState([]);
  const [commentLoading, setCommentLoading] = useState(false);
  const [replyText, setReplyText] = useState("");
  const [replyTo, setReplyTo] = useState(null);
  const [repliesMap, setRepliesMap] = useState({});
  const [loadingReplies, setLoadingReplies] = useState({});

  const openComments = async (post) => {
    setActivePost(post._id);
    setPostOwnerId(post?.user?._id);
    setShowCommentModal(true);
    setCommentLoading(true);
    try {
      const data = await feedApi.getCommentsByPost({ postId: post._id });
      setComments(data.comments || []);
    } catch (err) {
      console.error("Fetch comments failed:", err);
    } finally {
      setCommentLoading(false);
    }
  };

  const fetchReplies = async (commentId) => {
    if (repliesMap[commentId]) {
      setRepliesMap((prev) => {
        const copy = { ...prev };
        delete copy[commentId];
        return copy;
      });
      return;
    }
    setLoadingReplies((prev) => ({ ...prev, [commentId]: true }));
    try {
      const data = await feedApi.getRepliesByComment({ commentId });
      setRepliesMap((prev) => ({ ...prev, [commentId]: data.replies || [] }));
    } catch (err) {
      console.error("Fetch replies failed:", err);
    } finally {
      setLoadingReplies((prev) => ({ ...prev, [commentId]: false }));
    }
  };

  const handleAddReply = async (parentCommentId) => {
    if (!replyText.trim()) return;
    const text = replyText;
    setReplyText("");
    try {
      const data = await feedApi.addCommentReply({
        postId: activePost,
        content: text,
        parentCommentId,
      });
      if (!data.success) return;
      const newReply = {
        ...data.comment,
        user: data.comment.user || { fullName: "You" },
      };
      setRepliesMap((prev) => ({
        ...prev,
        [parentCommentId]: [...(prev[parentCommentId] || []), newReply],
      }));
      setComments((prev) =>
        prev.map((c) =>
          c._id === parentCommentId
            ? { ...c, repliesCount: c.repliesCount + 1 }
            : c,
        ),
      );
      setReplyTo(null);
    } catch (err) {
      console.error("Reply failed:", err);
    }
  };

  const [commentText, setCommentText] = useState("");
  const [isCommentSubmitting, setIsCommentSubmitting] = useState(false);

  const handleCommentLike = async (commentId) => {
    setComments((prev) =>
      prev.map((c) =>
        c._id === commentId
          ? {
              ...c,
              isLiked: !c.isLiked,
              likesCount: c.isLiked ? c.likesCount - 1 : c.likesCount + 1,
            }
          : c,
      ),
    );
    try {
      await feedApi.likeComment({ commentId });
    } catch (err) {
      console.error(err);
    }
  };

  const handleAddComment = async () => {
    if (!commentText.trim()) return;
    const text = commentText;
    setCommentText("");
    try {
      const data = await feedApi.addComment({
        postId: activePost,
        content: text,
      });
      if (!data.success) return;
      setComments((prev) => [data.comment, ...prev]);
      if (isActiveDataTab === "posts") {
        setMyPost((prev) =>
          prev.map((item) => {
            if (item._id !== activePost) return item;
            return { ...item, commentsCount: (item.commentsCount || 0) + 1 };
          }),
        );
      }
      if (isActiveDataTab === "saveposts") {
        setSavedPosts((prev) =>
          prev.map((post) =>
            post._id === activePost
              ? { ...post, commentsCount: (post.commentsCount || 0) + 1 }
              : post,
          ),
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const activeMediaRef = useRef({ type: null, el: null });
  const handleVideoPlay = (videoEl) => {
    if (activeMediaRef.current.el) {
      if (
        activeMediaRef.current.type !== "youtube" &&
        activeMediaRef.current.el !== videoEl
      ) {
        activeMediaRef.current.el.pause();
      }
    }
    activeMediaRef.current = { type: "video", el: videoEl };
  };

  const tabs = [
    { label: "Profile", value: "profile", icon: faUser },
    { label: "Posts", value: "posts", icon: faImage },
    { label: "Saved posts", value: "saveposts", icon: faBookmark },
    { label: "Share profile", value: "share", icon: faShareNodes },
    ...(profileData?.isProfileLocked
      ? [{ label: "Locked", value: "locked", icon: faLock }]
      : [{ label: "Lock", value: "lock", icon: faLockOpen }]),
  ];

  const visibleTabs = tabs.filter((tab) => {
    if (isOwner) {
      if (isPrime && ["lock", "locked"].includes(tab.value)) return false;
      return true;
    }
    return tab.value === "profile" || tab.value === "posts";
  });

  const handleProfileLock = async () => {
    const newLockState = !profileData?.isProfileLocked;
    setProfileData((prev) => ({ ...prev, isProfileLocked: newLockState }));
    try {
      const res = await profileApi.toggProfileLock(newLockState);
      setIsProfileLocked(res.user.isProfileLocked);
    } catch (err) {
      toast.error(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          "Something went wrong",
      );
      setProfileData((prev) => ({ ...prev, isProfileLocked: !newLockState }));
      setIsProfileLocked(false);
    }
  };

  const coverImageUrl = isOwner
    ? coverImage
      ? `${coverImage}`
      : CoverImg
    : profileData?.coverPic
      ? `${profileData.coverPic}`
      : CoverImg;

  const donationEnabled = profileData?.donationEnabled;
  const [isQR, setisQR] = useState(null);
  const closeQRPopup = () => setisQR(null);

  const handleDonation = async () => {
    try {
      const res = await api.get(`/donation/upi/${userId}`);
      if (!res.data) {
        toast.error("This user have no UPI available");
        return;
      }
      setisQR(res.data);
    } catch (error) {
      console.log(
        "Donation fetch failed:",
        error?.response?.data || error.message,
      );
    }
  };

  const isBatchCheck = profileData?.isBatch;
  const [isCoverDropDownShow, setIsCoverDropDownShow] = useState(false);

  const RemoveProfileImage = async () => {
    try {
      await api.patch("user/removeProfile ", { type: "profilePic" });
      toast.success("Profile picture removed successfully");
      setProfileData((prev) => ({ ...prev, profilePic: "null" }));
      setProfileImage(null);
      await updateProfile({ profilePic: "null" });
    } catch (error) {
      toast.error("Failed to remove profile picture");
    }
  };

  const RemoveCoverImage = async () => {
    try {
      await api.patch("user/removeProfile ", { type: "coverPic" });
      toast.success("Cover picture removed successfully");
      setIsCoverDropDownShow(false);
      setProfileData((prev) => ({ ...prev, coverPic: "null" }));
      setCoverImage(null);
      await updateProfile({ coverPic: "null" });
    } catch (error) {
      toast.error("Failed to remove cover picture");
    }
  };

  return (
    <>
      {IsSkeleton ? (
        <ProfileSkeleton />
      ) : (
        <section>
          <div className="profile-cover">
            <div
              className="profile-covers"
              style={{
                backgroundImage: `url(${coverImageUrl || coverImage})`,
                height: "360px",
                width: "100%",
                borderRadius: "10px",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundColor: "#f3f3f3",
                position: "relative",
              }}
            >
              {isMyProfile && (
                <>
                  <div
                    className="cover-image-edit"
                    ref={buttonRef}
                    onClick={() => setIsCoverDropDownShow((prev) => !prev)}
                  >
                    <div className="cover_image_dropdown">
                      <Icon icon="mdi:camera" width="22" />
                      {isCoverDropDownShow && (
                        <div
                          className="cover_image_option"
                          ref={coverDropDownRef}
                        >
                          <span
                            onClick={() => {
                              openCoverPicker();
                              setIsCoverDropDownShow(false);
                            }}
                          >
                            Add Cover Picture
                          </span>
                          <span onClick={() => RemoveCoverImage()}>
                            Remove Cover Picture
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    name="coverPic"
                    ref={coverInputRef}
                    style={{ display: "none" }}
                    onChange={handleCoverChange}
                  />
                </>
              )}

              {showCrop && (
                <div className="crop-modal">
                  <div className="crop-container">
                    <Cropper
                      key={editType}
                      image={selectedImage}
                      crop={crop}
                      zoom={zoom}
                      aspect={editType === "cover" ? 16 / 9 : 1}
                      cropShape={editType === "cover" ? "rect" : "round"}
                      onCropChange={setCrop}
                      onZoomChange={setZoom}
                      onCropComplete={onCropComplete}
                    />
                    <div className="crop-actions">
                      <button onClick={() => setShowCrop(false)}>Cancel</button>
                      <button
                        className="crop_save_button"
                        onClick={handleCropSave}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {!isMyProfile && donationEnabled === "ACCEPTED" && (
                <div
                  className="donation_QR_code_button"
                  onClick={handleDonation}
                >
                  Donate Now
                </div>
              )}
            </div>

            {isQR && (
              <QRCodePopup qrImage={isQR.upiUrl} onClose={closeQRPopup} />
            )}

            {/* Profile Info */}
            <div className="profile-info">
              <div className="profile-image-wrapper">
                <div className="profile-badge">
                  <div className="profile_badge_option">
                    <div className="profile_badge_section">
                      <img
                        src={
                          isOwner && profileImage
                            ? profileImage
                            : profileData?.profilePic ||
                              "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                        }
                        alt="Profile"
                        className="profile-image"
                        onError={(e) => {
                          e.target.src =
                            "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                        }}
                      />

                      {isBatchCheck && (
                        <div className="Bhagwa_dharBadge">
                          <img src={VandeMataram} alt="VandeMataram" />
                        </div>
                      )}

                      <FrameModal
                        isOpen={showFrameModal}
                        profileImage={profileImage}
                        badgeImage={VandeMataram}
                        onClose={() => setShowFrameModal(false)}
                        onApply={async (type) => {
                          const isBatchValue = type === "badge";
                          const badgeName =
                            type === "badge" ? "VandeMataram" : null;
                          setIsBadgeActive(isBatchValue);
                          setShowFrameModal(false);
                          setProfileData((prev) => ({
                            ...prev,
                            isBatch: isBatchValue,
                            badgeName,
                          }));
                          try {
                            await updateProfile({
                              isBatch: isBatchValue,
                              badgeName,
                            });
                          } catch (error) {
                            setIsBadgeActive(!isBatchValue);
                          }
                        }}
                      />
                    </div>

                    {isActive && (
                      <div className="my-openWork" ref={profileDropDownRef}>
                        <span
                          onClick={() => {
                            openFilePicker();
                            setIsActive(false);
                          }}
                        >
                          Upload Profile Picture
                        </span>
                        <span
                          onClick={() => {
                            setShowFrameModal(true);
                            setIsActive(false);
                          }}
                        >
                          Add Frame
                        </span>
                        <span
                          onClick={() => {
                            setIsActive(false);
                            RemoveProfileImage();
                          }}
                        >
                          Remove Profile Picture
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                {isMyProfile && (
                  <>
                    <div
                      className="profile-image-edit"
                      onClick={() => setIsActive((prev) => !prev)}
                    >
                      <Icon icon="mdi:camera" width="20" />
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      name="profilePic"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleProfileChange}
                    />
                  </>
                )}
              </div>

              <div className="profile-section-content">
                <div className="profesional-head-imfo">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column">
                      <h2 className="profile-heading d-flex align-items-center gap-1 flex-wrap">
                        {profileData?.fullName}

                        {isAadhaarVerified && (
                          <span
                            className={`aadhaar-verified-badge ${
                              !isPrime ? "text-primary" : "text-success"
                            }`}
                            title="Aadhaar Verified"
                          >
                            <Icon icon="ic:baseline-verified" />
                          </span>
                        )}
                        {isAadhaarRequested && isOwner && (
                          <button className="btn btn-sm aadhaar-verify-btn d-flex align-items-center gap-1 rounded-pill">
                            <span>Requested</span>
                          </button>
                        )}
                        {isAadhaarRejected && isOwner && (
                          <button className="btn btn-sm text-danger border-danger d-flex align-items-center gap-1 rounded-pill">
                            <span>Rejected</span>
                          </button>
                        )}
                        {(isAadhaarNone ||
                          isAadhaarRequested ||
                          isAadhaarRejected) &&
                          !isOwner && (
                            <span className="theme-color">
                              <Icon
                                icon="ic:sharp-warning-amber"
                                className="theme-color"
                              />
                            </span>
                          )}
                        {isAadhaarNone && isOwner && (
                          <button
                            className="btn btn-sm aadhaar-verify-btn d-flex align-items-center gap-1 rounded-pill"
                            onClick={handleAadhaarVerify}
                          >
                            <span className="theme-color">
                              <Icon
                                icon="ic:sharp-warning-amber"
                                className="theme-color"
                              />
                            </span>
                            <span>Verify Now</span>
                          </button>
                        )}
                      </h2>
                      <p className="profile-bio">{profileData?.bio}</p>
                    </div>

                    {!isOwner && !isBlockedByUser && (
                      <div className="profile-head-menu">
                        <BsThreeDots
                          onClick={() =>
                            setIsProfileActiveBtn(!isProfileActiveBtn)
                          }
                        />
                        {isProfileActiveBtn && (
                          <div className="profile-head-dropdown">
                            <button
                              disabled={
                                messageStatus === "REQUEST_SENT" ||
                                messageStatus === "REQUEST_RECEIVED"
                              }
                              className={
                                messageStatus === "REQUEST_RECEIVED" ||
                                messageStatus === "REQUEST_SENT"
                                  ? "btn disabled-look"
                                  : "btn"
                              }
                              onClick={() => {
                                if (messageStatus === "REQUEST_RECEIVED") {
                                  toast.info(
                                    "This user has already sent you a message request",
                                  );
                                  return;
                                }
                                if (messageStatus === "REQUEST_SENT") {
                                  toast.info("Message request already sent");
                                  return;
                                }
                                if (messageStatus === "CAN_MESSAGE") {
                                  goOnChat();
                                } else if (
                                  messageStatus === "NONE" ||
                                  messageStatus === "REJECTED"
                                ) {
                                  handleSendMessageRequest();
                                }
                              }}
                            >
                              <AiFillMessage />
                              {messageStatus === "REQUEST_RECEIVED"
                                ? "Request Received"
                                : messageStatus === "REQUEST_SENT"
                                  ? "Request Sent"
                                  : messageStatus === "NONE" ||
                                      messageStatus === "REJECTED"
                                    ? "Send Request"
                                    : "Message"}
                            </button>
                            <button
                              onClick={handleBlockToggle}
                              disabled={blockLoading}
                            >
                              <MdOutlineBlock />
                              {isBlockedUser ? "Unblock" : "Block"}
                            </button>
                            <button
                              onClick={handleReportProfile}
                              disabled={reportLoading}
                            >
                              <BsFlag />
                              {reportLoading ? "Reporting..." : "Report"}
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Stats */}
                <div className="profile-stats">
                  <div className="stat-item">
                    <span className="stat-count">
                      {profileData?.stats?.posts || postCount || 0}
                    </span>
                    <h2 className="stat-label">Posts</h2>
                  </div>
                  {profileData && !isPrime && (
                    <>
                      <div
                        className={`stat-item clickable ${
                          activeFollowTab === "followers" ? "active-follow" : ""
                        }`}
                        onClick={() => handleFollowClick("followers")}
                      >
                        <span className="stat-count">
                          {profileData?.followersCount || followersCount || 0}
                        </span>
                        <h2 className="stat-label">Followers</h2>
                      </div>
                      <div
                        className={`stat-item clickable ${
                          activeFollowTab === "following" ? "active-follow" : ""
                        }`}
                        onClick={() => handleFollowClick("following")}
                      >
                        <span className="stat-count">
                          {profileData?.followingCount ||
                            profileData?.stats?.following ||
                            0}
                        </span>
                        <h2 className="stat-label">Following</h2>
                      </div>
                    </>
                  )}
                </div>

                {/* ── FOLLOW / UNFOLLOW BUTTON ────────────────────────────────────────── */}

                {!isOwner &&
                  profileData &&
                  !isLoggedInPrimeUser &&
                  profileData?.role !== "PRIME" && (
                    <div className="follow-container row">
                      {followStatus === "NONE" && (
                        <div className="col-8">
                          <button
                            className="btn-follow w-100"
                            onClick={
                              isUserProfileLocked
                                ? handleSendFollowRequest
                                : handleFollow
                            }
                          >
                            Follow
                          </button>
                        </div>
                      )}

                      {followStatus === "FOLLOW_BACK" && (
                        <div className="col-8">
                          <button
                            className="btn-follow w-100"
                            onClick={handleFollow}
                          >
                            Follow Back
                          </button>
                        </div>
                      )}

                      {followStatus === "REQUESTED" && (
                        <div className="following-group col-8">
                          <button className="btn-requested">
                            Request Sent
                          </button>
                          <button
                            className="btn-requested-cancel"
                            onClick={handleCancelRequest}
                          >
                            Cancel Request
                          </button>
                        </div>
                      )}

                      {followStatus === "FOLLOWING" && (
                        <div className="following-group col-8">
                          <button className="btn-following" disabled>
                            Following
                          </button>
                          <button
                            className="btn-unfollow"
                            onClick={handleUnfollow}
                          >
                            Unfollow
                          </button>
                        </div>
                      )}
                    </div>
                  )}

                {/* Tabs */}
                {(isOwner || !isUserProfileLocked) &&
                  !isUserProfileLocked &&
                  !isBlockedUser &&
                  !isBlockedByUser && (
                    <div className="profile-tabs1">
                      {visibleTabs.map(({ label, value, icon }) => (
                        <div className="hell" key={value}>
                          <button
                            className={`tab-card1 ${
                              isActiveDataTab === value
                                ? "profile-active-tab"
                                : ""
                            }`}
                            onClick={() => {
                              closeFollowSection();
                              if (value === "share") {
                                handleShareProfile();
                                return;
                              }
                              if (!["lock", "locked"].includes(value))
                                setIsActiveDataTab(value);
                              if (value === "saveposts") fetchSavedPosts(null);
                              if (value === "lock" || value === "locked")
                                handleProfileLock();
                            }}
                          >
                            <FontAwesomeIcon icon={icon} className="me-2" />
                            {label}
                          </button>
                        </div>
                      ))}
                    </div>
                  )}

                {isProfileLocked === true && (
                  <span className="badge rounded-pill mt-2 py-2 profile-locked-badge">
                    You Have Locked Your Profile
                    <FontAwesomeIcon icon={faLock} className="ms-1" />
                  </span>
                )}

                {/* ── POSTS TAB (Cursor-based with Infinite Scroll) ─────────────────── */}
                {isActiveDataTab === "posts" &&
                  !isBlockedUser &&
                  !isBlockedByUser && (
                    <>
                      {!loading && myPost.length === 0 && (
                        <p className="not-found-text text-center mt-5">
                          No posts yet
                        </p>
                      )}

                      {(loading || myPost.length > 0) && (
                        <div className="mt-3 profile-post-main-container">
                          <div className="profile-post-container">
                            {loading &&
                              Array.from({ length: 4 }).map((_, index) => (
                                <PostSkeleton key={index} />
                              ))}

                            {!loading &&
                              myPost.map((item) => (
                                <div
                                  className="profile-post-card"
                                  key={item._id}
                                >
                                  <PostCard
                                    post={item}
                                    currentUserId={currentUserId}
                                    BASE_URL={BASE_URL}
                                    followLoading={followLoading}
                                    isPublic={true}
                                    userRole={profileData?.role}
                                    hideFollowButton={isLoggedInPrimeUser}
                                    onReport={report.openReport}
                                    handlers={{
                                      onEdit: handleEditPost,
                                      onDelete: handleDeletePost,
                                      onLike: handleLikeToggle,
                                      onSave: handleSaveToggle,
                                      onShare: handleShareClick,
                                      openImage: (imgs) => {
                                        setActiveImages(imgs);
                                        setShowImageModal(true);
                                      },
                                      onVideoPlay: handleVideoPlay,
                                      onFollowToggle: isPrime
                                        ? null
                                        : handleFollowToggle,
                                      onComment: openComments,
                                      videoRefs,
                                    }}
                                  />
                                </div>
                              ))}
                          </div>
                          {/* END .profile-post-container */}

                          {loadingMore && (
                            <div className="text-center my-3">
                              <div
                                className="spinner-border text-secondary"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          )}

                          {/* Sentinel for infinite scroll */}
                          <div
                            ref={sentinelRef}
                            style={{
                              height:
                                hasMore && myPost.length > 0 ? "20px" : "0px",
                              margin: "20px 0",
                              visibility:
                                hasMore && myPost.length > 0
                                  ? "visible"
                                  : "hidden",
                            }}
                          />

                          {!hasMore && myPost.length > 0 && (
                            <p className="text-center text-muted mb-4">
                              No more posts
                            </p>
                          )}
                        </div>
                      )}
                    </>
                  )}

                {/* ── SAVED POSTS TAB (Cursor-based with Infinite Scroll) ───────────── */}
                {isActiveDataTab === "saveposts" && (
                  <>
                    {!loading && savedPosts.length === 0 && (
                      <p className="not-found-text text-center mt-5">
                        No saved posts yet
                      </p>
                    )}

                    {(loading || savedPosts.length > 0) && (
                      <div className="mt-3 profile-post-main-container">
                        <div className="profile-post-container">
                          {loading &&
                            Array.from({ length: 4 }).map((_, index) => (
                              <PostSkeleton key={index} />
                            ))}

                          {!loading &&
                            savedPosts.map((item) => (
                              <div className="profile-post-card" key={item._id}>
                                <PostCard
                                  post={{
                                    ...item,
                                    ...item.post, // ✅ keep your merge fix
                                  }}
                                  currentUserId={currentUserId}
                                  BASE_URL={BASE_URL}
                                  followLoading={followLoading}
                                  isPublic={true}
                                  userRole={profileData?.role}
                                  hideFollowButton={isLoggedInPrimeUser}
                                  onReport={report.openReport}
                                  handlers={{
                                    onEdit: handleEditPost,
                                    onDelete: handleDeletePost,
                                    onLike: handleLikeToggle,
                                    onSave: handleSaveToggle,
                                    onShare: handleShareClick,
                                    openImage: (imgs) => {
                                      setActiveImages(imgs);
                                      setShowImageModal(true);
                                    },
                                    onVideoPlay: handleVideoPlay,
                                    onFollowToggle: isPrime
                                      ? null
                                      : handleFollowToggle,
                                    onComment: openComments,
                                    videoRefs,
                                  }}
                                />
                              </div>
                            ))}
                        </div>

                        {/* Optional: if you also want infinite scroll like posts */}
                        <div
                          ref={sentinelRef}
                          style={{
                            height:
                              hasMoreSaved && savedPosts.length > 0
                                ? "20px"
                                : "0px",
                            margin: "20px 0",
                            visibility:
                              hasMoreSaved && savedPosts.length > 0
                                ? "visible"
                                : "hidden",
                          }}
                        />

                        {!hasMoreSaved && savedPosts.length > 0 && (
                          <p className="text-center text-muted mb-4">
                            No more saved posts
                          </p>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
              {/* END .profile-section-content */}
            </div>
            {/* END .profile-info */}
          </div>
          {/* END .profile-cover */}

          {/* user public information */}
          {!isOwner &&
            !isUserProfileLocked &&
            !isBlockedUser &&
            !isBlockedByUser &&
            isActiveDataTab === "profile" && (
              <div className="profile-content">
                <div className="profile-details">
                  <div className="personal-info">
                    {activeTab === "personal" && (
                      <div className="card02">
                        <h3 className="card-heading01">Personal Information</h3>
                        <div className="info-column">
                          {profileData?.profession && (
                            <p>
                              <span className="label">Profession :</span>
                              <span className="value">
                                {profileData.profession}
                              </span>
                            </p>
                          )}
                          {profileData?.email && (
                            <p>
                              <span className="label">Email :</span>
                              <span className="value">{profileData.email}</span>
                            </p>
                          )}
                          {profileData?.age && (
                            <p>
                              <span className="label">Age :</span>
                              <span className="value">{profileData.age}</span>
                            </p>
                          )}
                          {profileData?.publicState && (
                            <p>
                              <span className="label">State :</span>
                              <span className="value">
                                {profileData.publicState}
                              </span>
                            </p>
                          )}
                          {profileData?.publicDistrict && (
                            <p>
                              <span className="label">District :</span>
                              <span className="value">
                                {profileData.publicDistrict}
                              </span>
                            </p>
                          )}
                          {profileData?.gender && (
                            <p>
                              <span className="label">Gender :</span>
                              <span className="value">
                                {profileData.gender}
                              </span>
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

          {/* Profile Lock for other user */}
          <div className="d-flex justify-content-center align-items-center mt-5">
            {isUserProfileLocked && !isOwner && (
              <div className="profile-lock-container text-center">
                <FontAwesomeIcon icon={faLock} size="2x" className="mb-3" />
                <h3>This Profile is Locked</h3>
              </div>
            )}
          </div>

          {/* My Profile Data */}
          {isActiveDataTab === "profile" && isOwner && (
            <div className="profile-content">
              <div className="profile-details">
                {profileView === "profile" &&
                  isActiveDataTab === "profile" &&
                  isOwner &&
                  !showFollowSection && (
                    <div className="profile-content">
                      <div className="profile-details">
                        <div className="profile-sidebar">
                          <button
                            className={`profile-btn ${activeTab === "personal" ? "active" : ""}`}
                            onClick={() => setActiveTab("personal")}
                          >
                            Personal Info
                          </button>
                          <button
                            className={`profile-btn ${activeTab === "password" ? "active" : ""}`}
                            onClick={() => setActiveTab("password")}
                          >
                            Change Password
                          </button>
                        </div>

                        <div className="personal-info">
                          {activeTab === "personal" && (
                            <div className="card02">
                              <h3 className="card-heading01">
                                Personal Information
                              </h3>
                              <div className="info-column">
                                {isProfileInfo?.statePublic && (
                                  <p>
                                    <span className="label">State :</span>
                                    <span className="value">
                                      {isProfileInfo.statePublic}
                                    </span>
                                  </p>
                                )}
                                {isProfileInfo?.districtPublic && (
                                  <p>
                                    <span className="label">District :</span>
                                    <span className="value">
                                      {isProfileInfo.districtPublic}
                                    </span>
                                  </p>
                                )}
                                {isProfileInfo?.status && (
                                  <p>
                                    <span className="label">
                                      Profile Status :
                                    </span>
                                    <span className="value">
                                      {isProfileInfo.status}
                                    </span>
                                  </p>
                                )}
                                {isProfileInfo?.verifiedUser != null && (
                                  <p>
                                    <span className="label">
                                      Verified User :
                                    </span>
                                    <span className="value">
                                      {isProfileInfo.verifiedUser
                                        ? "Yes"
                                        : "No"}
                                    </span>
                                  </p>
                                )}
                                {isProfileInfo?.gender && (
                                  <p>
                                    <span className="label">Gender :</span>
                                    <span className="value">
                                      {isProfileInfo.gender}
                                    </span>
                                  </p>
                                )}
                                {isProfileInfo?.email && (
                                  <p>
                                    <span className="label">Email :</span>
                                    <span className="value">
                                      {isProfileInfo.email}
                                    </span>
                                  </p>
                                )}
                                <Button
                                  onClick={handleFun}
                                  className="edit-profile-btn"
                                >
                                  Edit Profile
                                </Button>
                              </div>
                            </div>
                          )}

                          {activeTab === "password" && (
                            <div className="card02 password-card">
                              <h3>Change Password</h3>
                              <small
                                style={{
                                  display: "block",
                                  marginBottom: "10px",
                                  fontSize: "12px",
                                  color: "#666",
                                }}
                              >
                                Password must be 6-10 characters
                              </small>

                              {/* Current Password */}
                              <div style={{ position: "relative" }}>
                                <input
                                  placeholder="Current Password"
                                  type={
                                    showCurrentPassword ? "text" : "password"
                                  }
                                  autoComplete="new-password"
                                  value={form.currentPassword}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      currentPassword: e.target.value,
                                    })
                                  }
                                  style={{
                                    paddingRight: "40px",
                                    width: "100%",
                                  }}
                                />
                                <span
                                  onClick={() =>
                                    setShowCurrentPassword((prev) => !prev)
                                  }
                                  style={{
                                    position: "absolute",
                                    right: "12px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "#666",
                                  }}
                                >
                                  {showCurrentPassword ? (
                                    <FaEye />
                                  ) : (
                                    <FaEyeSlash />
                                  )}
                                </span>
                              </div>

                              {/* New Password */}
                              <div style={{ position: "relative" }}>
                                <input
                                  placeholder="New Password"
                                  type={showNewPassword ? "text" : "password"}
                                  autoComplete="new-password"
                                  value={form.newPassword}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value.length <= 10)
                                      setForm({ ...form, newPassword: value });
                                  }}
                                  style={{
                                    paddingRight: "40px",
                                    width: "100%",
                                  }}
                                />
                                <span
                                  onClick={() =>
                                    setShowNewPassword((prev) => !prev)
                                  }
                                  style={{
                                    position: "absolute",
                                    right: "12px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "#666",
                                  }}
                                >
                                  {showNewPassword ? <FaEye /> : <FaEyeSlash />}
                                </span>
                                {form.newPassword &&
                                  (form.newPassword.length < 6 ||
                                    form.newPassword.length > 10) && (
                                    <small
                                      style={{
                                        color: "red",
                                        fontSize: "12px",
                                        display: "block",
                                      }}
                                    >
                                      {form.newPassword.length < 6
                                        ? "Password must be at least 6 characters"
                                        : "Password must not exceed 10 characters"}
                                    </small>
                                  )}
                              </div>

                              {/* Confirm Password */}
                              <div style={{ position: "relative" }}>
                                <input
                                  placeholder="Confirm Password"
                                  type={
                                    showConfirmPassword ? "text" : "password"
                                  }
                                  autoComplete="new-password"
                                  value={form.confirmPassword}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value.length <= 10)
                                      setForm({
                                        ...form,
                                        confirmPassword: value,
                                      });
                                  }}
                                  style={{
                                    paddingRight: "40px",
                                    width: "100%",
                                  }}
                                />
                                <span
                                  onClick={() =>
                                    setShowConfirmPassword((prev) => !prev)
                                  }
                                  style={{
                                    position: "absolute",
                                    right: "12px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "#666",
                                  }}
                                >
                                  {showConfirmPassword ? (
                                    <FaEye />
                                  ) : (
                                    <FaEyeSlash />
                                  )}
                                </span>
                                {form.confirmPassword && (
                                  <small
                                    style={{
                                      fontSize: "12px",
                                      color:
                                        form.newPassword ===
                                          form.confirmPassword &&
                                        form.newPassword.length >= 6 &&
                                        form.newPassword.length <= 10
                                          ? "green"
                                          : "red",
                                      marginTop: "5px",
                                      display: "block",
                                    }}
                                  >
                                    {form.newPassword ===
                                      form.confirmPassword &&
                                    form.newPassword.length >= 6 &&
                                    form.newPassword.length <= 10
                                      ? "✓ Passwords match"
                                      : form.newPassword !==
                                            form.confirmPassword &&
                                          form.confirmPassword
                                        ? "✗ Passwords do not match"
                                        : ""}
                                  </small>
                                )}
                              </div>

                              <button
                                className="edit-profile-btn"
                                onClick={updatePassword}
                                disabled={
                                  !form.currentPassword ||
                                  !form.newPassword ||
                                  !form.confirmPassword ||
                                  form.newPassword.length < 6 ||
                                  form.newPassword.length > 10 ||
                                  form.newPassword !== form.confirmPassword ||
                                  loading
                                }
                                style={{
                                  opacity:
                                    !form.currentPassword ||
                                    !form.newPassword ||
                                    !form.confirmPassword ||
                                    form.newPassword.length < 6 ||
                                    form.newPassword.length > 10 ||
                                    form.newPassword !== form.confirmPassword
                                      ? 0.6
                                      : 1,
                                  cursor:
                                    !form.currentPassword ||
                                    !form.newPassword ||
                                    !form.confirmPassword ||
                                    form.newPassword.length < 6 ||
                                    form.newPassword.length > 10 ||
                                    form.newPassword !== form.confirmPassword
                                      ? "not-allowed"
                                      : "pointer",
                                }}
                              >
                                {loading ? "Updating..." : "Update Password"}
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          )}

          {/* Followers and Following */}
          {showFollowSection &&
            followListType &&
            currentUserId === profileData?._id && (
              <div className="follow-inline-section">
                <div className="follow-left-panel">
                  <h3 className="text-follow">
                    {followListType === "followers" ? "Followers" : "Following"}
                  </h3>
                </div>
                <div className="follow-list-panel">
                  {followListLoading ? (
                    Array.from({ length: 5 }).map((_, i) => (
                      <div key={i} className="follow-skeleton">
                        <div className="sk-avatar"></div>
                        <div className="sk-line"></div>
                      </div>
                    ))
                  ) : filteredFollowList.length > 0 ? (
                    filteredFollowList.map((user) => (
                      <div
                        key={user._id}
                        className="follow-user clickable"
                        onClick={() => openUserProfile(user._id)}
                      >
                        <img
                          src={getProfileImage(user.profilePic)}
                          alt={user.fullName}
                        />
                        <span>{user.fullName}</span>
                      </div>
                    ))
                  ) : (
                    <div className="empty-follow">
                      No {followListType} found
                    </div>
                  )}
                </div>
              </div>
            )}

          {/* Post Edit Modal */}
          {showEditModal && (
            <div className="modal fade show d-block" tabIndex="-1">
              <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content shadow-lg post-edit-modal-container">
                  <div className="modal-header">
                    <h5 className="modal-title">Edit Post</h5>
                    <button
                      className="btn-close"
                      onClick={() => setShowEditModal(false)}
                    />
                  </div>
                  <div className="modal-body">
                    <textarea
                      className="form-control mb-3"
                      rows={3}
                      value={editText}
                      onChange={(e) => setEditText(e.target.value)}
                      placeholder="Edit your post..."
                    />
                    {editImages.length > 0 && (
                      <div className="image-preview-box">
                        {editImages.map((img, i) => (
                          <div key={i} className="preview-image-wrapper">
                            <img
                              src={img.preview}
                              className="preview-image"
                              alt=""
                            />
                            <span
                              className="remove-img"
                              onClick={() => handleRemoveEditImage(i)}
                            >
                              ×
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                    {editVideo && (
                      <div className="video-preview-box">
                        <div className="preview-video-wrapper">
                          <video
                            src={editVideo.preview}
                            controls
                            className="video-preview"
                          />
                          <span className="video-type-label">
                            {editVideoType === "short"
                              ? "🎬 Short Video"
                              : "🎥 Long Video"}
                          </span>
                          <span
                            className="remove-video"
                            onClick={handleRemoveEditVideo}
                          >
                            ×
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="d-flex gap-3 mt-3">
                      <label className="cursor-pointer">
                        <FontAwesomeIcon icon={faImage} className="me-2" />
                        Add Images
                        <input
                          ref={editImageInputRef}
                          type="file"
                          multiple
                          accept="image/*"
                          hidden
                          onChange={handleEditImageSelect}
                        />
                      </label>
                      <label className="cursor-pointer">
                        <FontAwesomeIcon icon={faVideo} className="me-2" />
                        Add Video
                        <input
                          ref={editVideoInputRef}
                          type="file"
                          accept="video/*"
                          hidden
                          onChange={handleEditVideoSelect}
                        />
                      </label>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowEditModal(false)}
                      disabled={isUpdating}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={handleUpdatePost}
                      disabled={isUpdating}
                    >
                      {isUpdating ? "Updating..." : "Update Post"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Comment Modal */}
          <CommentModal
            show={showCommentModal}
            onClose={() => setShowCommentModal(false)}
            comments={comments}
            commentLoading={commentLoading}
            BASE_URL={BASE_URL}
            currentUserId={currentUserId}
            postOwnerId={postOwnerId}
            commentText={commentText}
            setCommentText={setCommentText}
            replyText={replyText}
            setReplyText={setReplyText}
            replyTo={replyTo}
            setReplyTo={setReplyTo}
            onAddComment={handleAddComment}
            onAddReply={handleAddReply}
            onLikeComment={handleCommentLike}
            onFetchReplies={fetchReplies}
            onDelete={handleDeleteComment}
            repliesMap={repliesMap}
            loadingReplies={loadingReplies}
            activeMenuId={activeMenuId}
            setActiveMenuId={setActiveMenuId}
            showDeleteConfirm={showDeleteConfirm}
            setShowDeleteConfirm={setShowDeleteConfirm}
            deleteType={deleteType}
            setDeleteTargetId={setDeleteTargetId}
            setDeleteType={setDeleteType}
            setParentCommentId={setParentCommentId}
            onReport={report.openReport}
          />

          {/* Image Modal */}
          {showImageModal && (
            <div className="image-modal">
              <span
                className="close-modal"
                onClick={() => setShowImageModal(false)}
              >
                ×
              </span>
              <Swiper
                modules={[Navigation, Pagination, Keyboard]}
                navigation
                pagination={{ clickable: true }}
                keyboard={{ enabled: true }}
                spaceBetween={20}
                slidesPerView={1}
                className="image-swiper"
              >
                {activeImages.map((img, index) => (
                  <SwiperSlide key={index}>
                    <TransformWrapper
                      pinch={{ disabled: false }}
                      doubleClick={{ disabled: false }}
                      wheel={{ step: 0.1 }}
                    >
                      <TransformComponent>
                        <img
                          src={`${img.replace(/\\/g, "/")}`}
                          className="modal-image"
                          alt="post"
                        />
                      </TransformComponent>
                    </TransformWrapper>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          )}

          {/* Report Modal */}
          <ReportModal
            show={report.showModal}
            step={report.step}
            reason={report.reason}
            subReason={report.subReason}
            setReason={report.setReason}
            setSubReason={report.setSubReason}
            onNext={() => report.setStep(2)}
            onBack={() => {
              report.setSubReason(null);
              report.setStep(1);
            }}
            onSubmit={report.submitReport}
            loading={report.loading}
            onClose={() => report.setShowModal(false)}
          />

          {/* Share Modal */}
          <ShareModal
            post={sharePost}
            onClose={() => setSharePost(null)}
            onInternalShare={handleInternalShare}
            onExternalShare={handleExternalShare}
            onRepost={handleRepost}
          />
        </section>
      )}
    </>
  );
}
